import { Product } from '@/features/types/product';

import IconShield from '~/svg/IconShield.svg';
import IconAmex from '~/svg/payments/IconAmex.svg';
import IconApplePay from '~/svg/payments/IconApplePay.svg';
import IconBTC from '~/svg/payments/IconBTC.svg';
import IconCrypto from '~/svg/payments/IconCrypto.svg';
import IconGooglePay from '~/svg/payments/IconGooglePay.svg';
import IconMastercard from '~/svg/payments/IconMastercard.svg';
import IconPaypal from '~/svg/payments/IconPaypal.svg';
import IconVisa from '~/svg/payments/IconVisa.svg';

import IconAlipay from '~/svg/payments/IconAlipay.svg';
import IconUnionPay from '~/svg/payments/IconUnionPay.svg';
import IconTether from '~/svg/payments/IconTether.svg';
import { useTranslation } from '@/lib/i18n/i18n.client';

const productsToExcludeCrypto: Product[] = [
  'datacenter_ip',
  'isp_gb',
  'isp_ip',
  'dedicated_isp',
];

type PaymentMethodsProps = {
  product: Product;
  title?: string;
  description?: string;
};

export function PaymentMethods({
  product,
  title,
  description,
}: PaymentMethodsProps) {
  const { texts, lang } = useTranslation();

  return (
    <div className='mx-auto my-0 mt-12 flex w-full flex-col items-start justify-between gap-8 md:items-center lg:flex-row lg:gap-6'>
      <div className='flex items-center gap-4'>
        <IconShield className='text-neutral-N20 max-h-9 min-h-9 min-w-9 max-w-9' />
        <div className='text-left'>
          <p className='text-body-m text-neutral-N50'>
            {title || texts.pricing_cards.payment_methods.ssl_secure_payment}
          </p>
          <p className='text-body-s text-neutral-N50'>
            {description ||
              texts.pricing_cards.payment_methods.ssl_protected_information}
          </p>
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-wrap justify-start gap-6 opacity-50 md:justify-evenly'>
          {lang === 'zh-cn' && (
            <>
              <IconAlipay />
              <IconUnionPay />
              <IconTether />
            </>
          )}
          <IconVisa />
          <IconMastercard />
          <IconPaypal />
          <IconAmex />
          {!productsToExcludeCrypto.includes(product) && <IconBTC />}
          {!productsToExcludeCrypto.includes(product) && <IconCrypto />}
          <IconApplePay />
          <IconGooglePay />
        </div>
        {lang !== 'zh-cn' && (
          <p className='text-body-s text-neutral-N50 text-start md:text-center lg:text-right'>
            {texts.pricing_cards.payment_methods.mobile_pay}
          </p>
        )}
      </div>
    </div>
  );
}
